import { PartnersPageRoot } from "./PartnersPage.styles";
import PartnersList from "ui/partners/components/PartnersList/PartnersList";
import SearchBarFilter from "ui/partners/components/SearchBarFilter/SearchBarFilter";
import AdsCarousel from "ui/common/components/feedback/AdsCarousel/AdsCarousel";
import { useGetPartnersBanners } from "ui/partners/hooks/useGetPartnersBanners";

export default function PartnersPage() {
    const { banners } = useGetPartnersBanners();

    return (
        <PartnersPageRoot>
            <SearchBarFilter />
            <PartnersList />
            <AdsCarousel data={banners} showPagination={false}/>
        </PartnersPageRoot>
    );
}
